// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"0e44f4f4","202":"fe2c30b5","680":"06202509","771":"d2608492","835":"fd78be1b"}[chunkId] + ".css";
};